import React, { createContext, useContext, SetStateAction, useLayoutEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useLocalStorage } from "../../sg-hooks/useLocalStorage";
import { AUDIT_FILTERS, AUDIT_PAGINATION } from "../constants/StorageKeys";
import { IPagination } from "../interfaces/common/IPagination";
import { IAuditListFilters } from "../interfaces/IAudit";

const INITIAL_FILTERS = { roles: [] };
const INITIAL_PAGINATION = { page: 1, pageSize: 10 };


interface IAuditListFiltersContext {
    filters: IAuditListFilters;
    pagination: IPagination

    updateFilters: (updates: Partial<IAuditListFilters>) => void;
    setFilters: (updates: IAuditListFilters) => void;

    setPagination: (set: SetStateAction<IPagination>) => void;
}

const noop = () => undefined;

const defaultValue: IAuditListFiltersContext = {
    filters: INITIAL_FILTERS,
    pagination: INITIAL_PAGINATION,
    updateFilters: noop,
    setFilters: noop,
    setPagination: noop

};

const context = createContext<IAuditListFiltersContext>(defaultValue);
const { Provider } = context;

export const useAuditListFiltersContext = () => useContext(context);

// Provider
export const AuditListFiltersProvider: React.FC = ({ children }) => {
    const history = useHistory()
    const location = useLocation<{ filters: IAuditListFilters }>();

    const [filters, setFilters] = useLocalStorage<IAuditListFilters>(AUDIT_FILTERS, INITIAL_FILTERS);
    const [pagination, setPagination] = useLocalStorage<IPagination>(AUDIT_PAGINATION, INITIAL_PAGINATION);

    const updateFilters = (updates: Partial<IAuditListFilters>) => {
        setFilters((prevFilters) => ({ ...prevFilters, ...updates }));
        setPagination(INITIAL_PAGINATION);
    };

    // Update filters from location 
    useLayoutEffect(() => {
        //@ts-ignore
        if (location.state?.filters) {
            history.replace(location.pathname)
            setFilters(location.state.filters);
        }
    }, [history, location.pathname, location, setFilters])


    const value: IAuditListFiltersContext = {
        filters,
        updateFilters,
        setFilters,

        pagination,
        setPagination
    };

    return (
        <Provider value={value}>
            {children}
        </Provider>
    );
};
